import { render } from "preact";

import { App } from "./app";
import { watchInstall } from "./lib/install";
import * as chrome from "./lib/chrome";
import { watchIdle } from "./lib/idle";
import { androidBack, watchHistory } from "./lib/navigation";
import * as push from "./lib/push";
import * as android from "./lib/android";
import { hydrateDeviceToken, watchTheme } from "./lib/settings";
import { watchViewport } from "./lib/viewport";
import "./styles.css";

watchTheme();
watchInstall();
// Watches for the session and the mode together and does nothing at all until
// both hold, so this costs an ordinary sign-in one signal subscription. Started
// here rather than from a component because it must outlive every screen: the
// timer's whole job is to fire while nobody is looking at any of them.
watchIdle();
// The worker is registered on every load, not only when notifications are on:
// it is also what answers a click on a notification, and `serviceWorker.ready`
// has to have resolved before anything in `lib/push.ts` can look at a
// subscription. It registers no listeners that cost anything when push is off,
// and makes no request to the daemon.
push.watchServiceWorker();
// Before `watchHistory`, so the `?open=` a notification click arrived with is
// off the URL by the time history starts mirroring it -- the same ordering the
// OAuth return parameters need, and for the same reason.
push.takeOpenTarget();
// After the imports have run, so the `replaceState` in `lib/accounts.ts` --
// which strips the OAuth return parameters at import time -- has already
// settled on the URL this adopts.
watchHistory();
watchViewport();
// Re-registers an existing subscription so the row follows the session that is
// signed in now. It subscribes to nothing and prompts for nothing, so a browser
// that has never turned notifications on makes no request at all.
void push.syncOnLaunch();

const root = document.getElementById("app");
if (!root) throw new Error("index.html is missing #app");

// The token before the first request, not alongside it.
//
// `App` asks `/auth/whoami` as it mounts, and a request that goes out before the
// stored token is in hand carries no credential and is answered 401 -- which
// this client correctly reads as "signed out" and renders as a login screen. So
// the race presents as being asked to sign in while already signed in, which is
// both wrong and the kind of wrong that looks like a server problem.
//
// In the browser this resolves in the same tick, because it is `localStorage`
// behind a promise. On the desktop it is a round trip to the OS keychain, which
// is precisely why it is awaited rather than assumed.
//
// The window chrome joins it for the same reason and not a weaker one: whether
// this platform left the system titlebar in place decides whether the app draws
// its own buttons, and a page that painted a set and then discovered the OS was
// already drawing some would show two for a frame. Settled before the first
// paint or not at all. Neither call can reject -- both swallow their own
// failures -- so `finally` still renders.
// The Android shell's two facts, before the first paint: the insets it
// measured, and the hook its back gesture calls. No-ops everywhere else.
android.applyInsets();
android.installBackHandler(androidBack);

void Promise.all([hydrateDeviceToken(), chrome.probe()]).finally(() => render(<App />, root));
